/**  
 *  Developers: Sakshi Bhise  
 *  File: msalConfig.tsx  
 *  Date: 06/18/2025  
 *  Project Name: AskHR  
 *  Team: DSET  
 *   
 *  Purpose:  
    - Defines the Microsoft Authentication Library (MSAL) configuration for the AskHR frontend.  
    - Provides authentication settings including clientId, authority, and redirectUri.  
    - Specifies how auth state is cached and which scopes are requested during login.    
 */  

// ================= Imports ================= // 
import { Configuration } from "@azure/msal-browser";

// ================= MSAL Configuration ================= //
export const msalConfig: Configuration = {
auth: {
clientId: "8a5abeee-026f-4116-9a5a-78f0fb51569c", // <-- replace with your app's clientId
authority: "https://login.microsoftonline.com/3f991a7b-ea93-4169-b28c-c36ff3e5b0d1", // <-- replace with your tenantId (or 'common')
redirectUri: window.location.origin + '/signin' // Redirect URI after login set in app's configuration
},
cache: {
cacheLocation: "localStorage", // Store tokens in localStorage for persistence
storeAuthStateInCookie: false, // Don't use cookies (recommended for SPA)
}
};

// ================= Login Request Scopes ================= //
export const loginRequest = {
scopes: ["User.Read"], // Add other Microsoft Graph scopes if needed
};